import { Icons } from "@caspeco/casper-ui-library";
import { PageType } from "logger/page-tracking";
import { usePageTracking } from "logger/use-page-tracking";
import { Dispatch, SetStateAction, useCallback } from "react";
import { useTranslation } from "react-i18next";
import ErrorTemplate from "./error-template";

type ServerNotReponseProps = {
    lastCall?: { fn: (...args: unknown[]) => void; args: unknown[] };
    setLastCall?: Dispatch<SetStateAction<{ fn: () => void; args: unknown[] } | undefined>>;
};

export default function ServerDidNotRespond({ lastCall, setLastCall }: ServerNotReponseProps) {
    const { t } = useTranslation();

    usePageTracking({
        pageName: "ServerDidNotRespondError",
        pageType: PageType.Page,
    });

    const handleRetry = useCallback(() => {
        if (lastCall) {
            lastCall.fn(...lastCall.args);
        }
        // Optionally reset the lastCall state after retrying
        if (setLastCall) {
            setLastCall(undefined);
        }
    }, [lastCall, setLastCall]);

    return (
        <ErrorTemplate
            icon={Icons.Sweat}
            title={t("errorInformation.serverErrror")}
            message={t("errorInformation.serverLost")}
            btnCallback={handleRetry}
            btnText={t("errorInformation.tryAgain")}
            trackingId="error-server-not-respond-try-again"
        />
    );
}
